export const anticipationDrawer = {
	title: "Request Anticipation and Bill Payment",
	titleAnticipation: "Request Anticipation",
	titleBilletPayment: "Request Bill Payment",
	anticipationValue: "Anticipation value",
	accountData: "Account information",
	summary: "Data review",
	warningBanner:
		"Requests made after 10:30 am (Brasília time) will only be dealt with the following day.",
	warningAccountChoice:
		"A fee of {{value}} will be charged for anticipation on third-party accounts.",
	formStatusError: "The request could not be completed.",
	formStatusSuccess: "Advance requested successfully!",
	form: {
		selectAccountPlaceholder: "Enter or select account",
		liquidValue: "Net value",
		liquidValuePlaceholder: "Enter the net amount here",
		totalValue: "Total to be anticipated",
		totalValueTooltip: "The net amount plus the advance fee.",
		reason: "Reason for request",
		reasonPlaceholder: "Enter here the reason for the anticipation",
		accountType: "Transfer to",
		accountTypes: {
			default: "Default account",
			existing: "Registered account",
			new: "New account",
			tooltip: "The one signed in contract",
		},
		shouldSaveForFutureRequests: "Save account for future transactions",
		bankData: "Bank data",
		name: "Account identifier",
		summaryTitle: "Review of values",
		summaryReason: "Reason",
		summaryValue: "Requested amount",
		summaryAnticipationFee: "Anticipation fee",
		summaryLiquidValue: "Liquid value requested",
		summaryThirdPartyFee: "Third party anticipation fee",
		summaryTotal: "Total amount to be anticipated",
		withdrawAll: "Anticipate all available value",
	},
};
